import storeModule from './store'
import NotificationsHelper from './helper'

export default {
	install(Vue, {
		store,
	}) {
		store.registerModule('notifications', storeModule)

		const helper = new NotificationsHelper(store)
		Vue.prototype.$notifications = helper
	},
}
